import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import classNames from 'classnames'

import StatsTable from 'components/StatsTable/StatsTable.jsx'

import styles from './Statistics.scss'

const Statistics = (props) => {

    const divisions = Object.keys(props.clanStats).map(division => {
        const divisionClassName = classNames(styles.division, styles[`division__${division}`])
        return (
            <div key={`rating-in-${division}`} className={styles.divisionItem}>
                <div className={divisionClassName}>
                    <FormattedNumber value={props.clanStats[division].elo} />
                </div>
            </div>
        )
    })

    const statsTables = Object.keys(props.clanStats).map(division => {
        return (
            <div key={`stats-in-${division}`} className={styles.table}>
                <StatsTable {...props.clanStats[division]} level={division} theme={StatsTable.themes.external} />
            </div>
        )
    })
    return (
        <div className={styles.base}>
            <div className={styles.divisions}>
                {divisions}
            </div>
            <div className={styles.tables}>
                {statsTables}
            </div>
        </div>
    )
}

Statistics.propTypes = {
    clanStats: PropTypes.object.isRequired,
}

export default Statistics



// WEBPACK FOOTER //
// ./containers/StrongholdExternal/components/Statistics/Statistics.jsx